import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FilesList } from 'containers/misc'
import { FloatingBar, ButtonGroup, FormButton } from 'components/misc'
import { AwardFileInfo } from 'components/sections/awards'
import { Form } from 'components/layout'
import { form } from 'helpers/decorators'

@form({
  form: 'award-file-detail',
  initialProps: 'awards.files.detail'
})
class AwardFileDetail extends Component {
  static propTypes = {
    deleteAwardFile: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    editAwardFile: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    awards: PropTypes.object.isRequired,
    pristine: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    initialize: PropTypes.func
  }

  render() {
    const {
      awards,
      handleSubmit,
      pristine,
      submitSucceeded,
      submitFailed,
      invalid,
      codeLists,
      initialize
    } = this.props

    return (
      <Form onSubmit={handleSubmit(this.props.editAwardFile)}>
        <div className="row">
          <div className="col-xs-5">
            <AwardFileInfo codeLists={codeLists} initialize={initialize} />
          </div>
        </div>
        {get(awards, 'files.detail.fileUrl') &&
          <FilesList
            noLink
            files={[awards.files.detail]}
            deleteAwardFile={this.props.deleteAwardFile}
            hasTitle={false}
          />}
        <FloatingBar>
          <ButtonGroup right>
            <FormButton
              pristine={pristine}
              submitSucceeded={submitSucceeded}
              submitFailed={submitFailed}
              invalid={invalid}
              type="submit"
              intlKey="button.save"
            >
              Save
            </FormButton>
          </ButtonGroup>
        </FloatingBar>
      </Form>
    )
  }
}

export default AwardFileDetail
